import { clientforssr, clientforssrca, clientforssrnz, clientforssrInt, clientforssrCacheql, clientforssrCacheqlNZ, clientforssrCacheqlCA } from '../apolloclient';

export const handleregionapollo = (locale: string | undefined) => {
  if (process.env.NEXT_PUBLIC_CACHE === 'true') {
    if (locale === 'ca') {
      return clientforssrCacheqlCA;
    } else if (locale === 'nz') {
      return clientforssrCacheqlNZ;
    } else {
      return clientforssrCacheql;
    }
  }

  if (locale === 'ca') {
    return clientforssrca;
  } else if (locale === 'nz') {
    return clientforssrnz;
  } else if (locale === 'international') {
    return clientforssrInt;
  } else {
    return clientforssr;
  }
};

function getRealUrl(url: any) {
  return url.replace('/graphql', '').replace('/wp', '');
}

export const handleRegionUrl = (locale: string | undefined) => {
  if (locale === 'ca') {
    return getRealUrl(process.env.NEXT_PUBLIC_NEXT_APP_API_URL_CA);
  } else if (locale === 'nz') {
    return getRealUrl(process.env.NEXT_PUBLIC_NEXT_APP_API_URL_NZ);
  } else if (locale === 'international') {
    return getRealUrl(process.env.NEXT_PUBLIC_NEXT_APP_API_URL_INT);
  } else {
    return getRealUrl(process.env.NEXT_PUBLIC_NEXT_APP_API_URL);
  }
};
